import { FC } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { Typography } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { resourceGridListingPriceFrequencySelector } from "@/store/resources-grid/selectors/grid/resourceGridListingPriceFrequencySelector";
import { money as moneyConverter } from "@/utils/numeral/money";

export const ResourceListingPriceCellRenderer: FC<ICellRendererParams> = ({
  data,
  ...props
}) => {
  const listingPrice = data?.resource?.listing_price;
  const resourceType = data?.resource_type;
  const masterGridId = props.context?.masterGridId;

  const frequency = useAppSelector((state) =>
    resourceGridListingPriceFrequencySelector(
      state,
      resourceType,
      masterGridId,
    ),
  );

  if (!frequency) {
    return;
  }

  return (
    <Typography variant="body2">
      {moneyConverter(listingPrice?.[frequency])}
    </Typography>
  );
};
